import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const Absolute = styled(Flex, {
  position: 'absolute',
});
